import { Component } from '@angular/core';

@Component({
    selector: 'app-copyright',
    standalone: true,
    imports: [],
    templateUrl: './copyright.component.html',
    styleUrl: './copyright.component.css'
})
export class CopyrightComponent {

    public year: number = new Date().getFullYear();

    constructor() { }
}
